// extracted by mini-css-extract-plugin
export default {"tooltip":"PmrHandlerTooltip_tooltip__I1u+U","tooltip-content":"PmrHandlerTooltip_tooltip-content__Bj0ac"};